import { whiteColor, hexToRgb, warningColor } from 'assets/jss/material-dashboard-pro-react';

const attentionCCLimitNoteStyle = () => ({
	neutralBackground: {
		backgroundColor: whiteColor,
	},
	ccLimitNoteWrapper: {
		backgroundColor: `rgba(${hexToRgb(warningColor[0])}, 0.1)`,
		padding: '10px 20px',
		display: 'flex',
		alignItems: 'center',
		borderRadius: '8px',
		textAlign: 'left',
	},
	image: {
		marginRight: 14,
	},
});

export default attentionCCLimitNoteStyle;
